import { motion } from 'framer-motion';

interface OnboardingDotsProps {
  currentStep: number;
  totalSteps: number;
  onStepClick?: (step: number) => void;
}

export const OnboardingDots = ({ currentStep, totalSteps, onStepClick }: OnboardingDotsProps) => {
  return (
    <div className="flex items-center justify-center gap-2">
      {Array.from({ length: totalSteps }).map((_, index) => (
        <motion.button
          key={index}
          type="button"
          onClick={() => onStepClick?.(index)}
          className={`h-2 rounded-full transition-colors duration-300 ${
            index === currentStep
              ? 'bg-primary'
              : 'bg-muted'
          }`}
          animate={{
            width: index === currentStep ? 24 : 8,
          }}
          transition={{
            type: 'spring',
            stiffness: 300,
            damping: 30,
          }}
        />
      ))}
    </div>
  );
};
